import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const NoAccess = () => {
  const { user } = useAuth();
  const location = useLocation();
  const from = location.state?.from?.pathname || '';

  return (
    <div style={{
      minHeight: '70vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      padding: 24,
      textAlign: 'center',
    }}>
      <div style={{ fontSize: 64, marginBottom: 8 }}>🔒</div>
      <h2 style={{ margin: 0, marginBottom: 8 }}>Access denied</h2>
      <p style={{ color: '#666', maxWidth: 520 }}>
        You don't have permission to view this page.
        {from ? ` (${from})` : ''}
      </p>
      <p style={{ color: '#666', fontSize: 13 }}>
        Signed in as <strong>{user?.name || '—'}</strong>
        {user?.roles?.length ? (
          <> · Roles: <code>{user.roles.join(', ')}</code></>
        ) : null}
      </p>
      <Link to="/dashboard" style={{
        marginTop: 20, padding: '10px 18px', background: '#94335a',
        color: '#fff', textDecoration: 'none', borderRadius: 6,
      }}>
        Back to dashboard
      </Link>
    </div>
  );
};

export default NoAccess;
